<template>
	<div>
		<b-form>
			<b-row class="mt-4">
				<b-col xl="4" lg="4" sm="4">
					<b-form-group label-for="input-1">
						<label for="name"><b>Name</b></label>
						<b-form-input
							id="name"
							v-model="updateUserForm.name"
							:state="nameStatus"
							@blur="onBlur($event)"
						></b-form-input>
					</b-form-group>
				</b-col>
				<b-col xl="4" lg="4" sm="4">
					<b-form-group label-for="input-1">
						<label for="username"><b>Username</b></label>
						<b-form-input id="username" v-model="updateUserForm.username" readonly></b-form-input>
					</b-form-group>
				</b-col>
				<b-col xl="4" lg="4" sm="4">
					<b-form-group label-for="input-1">
            <label for="phone-number"><b>Phone Number</b></label>
            <vue-tel-input
                style="font-weight: 400;line-height: 1.5;!important;"
                v-model="updateUserForm.phone"
                :defaultCountry="preferredCountry"
                :enabledCountryCode="enabledCountryCodeStatus"
                :state="phoneStatus"
                :validCharactersOnly="validCharactersOnly"
            ></vue-tel-input>
            <b-form-invalid-feedback :state="phoneStatus">
              Please enter a valid phone number.
            </b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="6">
					<b-form-group label-for="input-1">
						<label for="email"><b>Email</b></label>
						<b-form-input
							id="email"
							type="email"
							:state="emailStatus"
							v-model="updateUserForm.email"
							@blur="onBlur($event)"
						></b-form-input>
						<b-form-invalid-feedback :state="emailStatus">
							{{ emailStatusMessage }}
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
				<b-col xl="6">
					<b-form-group label-for="input-1">
						<label for="password"><b>Reset Password</b></label>
						<b-input-group>
							<b-form-input
								id="password"
								placeholder="Reset Password"
								:type="isShowPassword ? 'text' : 'password'"
								autocomplete="new-password"
								:state="passwordStatus"
								v-model="updateUserForm.password"
								@input="setStateOverride(false)"
								@blur="onBlur($event)"
							>
							</b-form-input>
							<b-input-group-append>
								<b-button variant="outline-primary" @click="isShowPassword = !isShowPassword">
									<b-icon icon="eye-slash" v-if="isShowPassword" />
									<b-icon icon="eye" v-else />
								</b-button>
							</b-input-group-append>
						</b-input-group>
						<b-form-invalid-feedback :state="stateOverride || passwordLength">
							Your password must have at least 8 chars.
						</b-form-invalid-feedback>
						<b-form-invalid-feedback :state="stateOverride || passwordUppercase">
							Your password must have at least 1 upper case letter.
						</b-form-invalid-feedback>
						<b-form-invalid-feedback :state="stateOverride || passwordNumber">
							Your password must have at least 1 number.
						</b-form-invalid-feedback>
						<b-form-invalid-feedback :state="stateOverride || passwordCharacter">
							Your password must have at least 1 special char.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<label for="customerGroup"><b>Carrier</b></label>
					<b-form-select
						id="customerGroup"
						v-model="updateUserForm.customerGroup"
						:state="customerGroupStatus"
						class="mb-1"
					>
					<!-- Hide the first option in the dropdown -->
					<template v-slot:first>
						<option value="" disabled>Select Carrier</option>
					</template>
					<option v-for="option in customerGroupOptions" :value="option.value" :key="option.value">
						{{ option.text }}
					</option>
					</b-form-select>
					<b-form-invalid-feedback :state="customerGroupStatus">
							Please select a Carrier.
					</b-form-invalid-feedback>
				</b-col>
			</b-row>
			<b-row>
        		<b-col xl="12">
					<b-form-group>
						<label for="roles"><b>Roles</b></label>
						<div style="display: flex; gap: 0.25em; flex-wrap: wrap">
							<span v-for="role in selectedRoles">
								<b-badge href="#" :title="`Remove ${role}`" variant="primary" @click="removeRole(role)"
									>{{ role }} <b-icon icon="x"></b-icon>
								</b-badge>
							</span>
						</div>
						<b-form-select id="roles" :value="selectedRoles" multiple class="mt-1" @mousedown.prevent>
							<option
								v-for="option in roleOption"
								:value="option.value"
								:key="option.value"
								@click="onSelect"
								:state="customerRoleStatus"
							>
								{{ option.text }}
							</option>
						</b-form-select>
					<b-form-invalid-feedback :state="customerRoleStatus">
							Please select at least 1 Role.
					</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
				<b-col xl="2" lg="2" sm="2" />
			</b-row>
			<b-row>
				<b-col>
					<div class="d-flex justify-content-end">
						<base-button type="info" title="Close" v-on:click="modalClose()"> Cancel </base-button>
						<base-button
							:disabled="submitDisabled"
							:loading="submitLoading"
							:title="submitDisabled ? 'No Changes' : 'Save'"
							type="info"
							v-on:click="changeGroupSubmit"
						>
							Save
						</base-button>
					</div>
				</b-col>
			</b-row>
		</b-form>
	</div>
</template>

<script>
import {VueTelInput} from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import administratorService from "../../common/api-services/administrator-service";
import handleResponse from "../../common/directive/handlResponse";
import AdministratorService from "../../common/api-services/administrator-service";
import initService from "../../common/api-services/init-service";
import configDirective from "../../common/directive/config-directive";
import Toast from "./Toast.vue";

export default {
	name: "Change-User",

	components: {
		VueTelInput,
		Toast,
	},

	data() {
		return {
			selectedRoles: [],
			newRoles: [],
			updateUserForm: {
				name: "",
				oldCustomerGroup: "",
				customerGroup: "",
				oldName: "",
				username: "",
				oldUsername: "",
				email: "",
				oldEmail: "",
				phone: "",
				oldPhone: "",
				password: "",
			},
			stateOverride: true,
			roleOption: [],
			customerGroupOptions: [],
			submitLoading: false,
			isShowPassword: false,
			rolesChanged: false,
			customer: null,

      //for phone number validator
      enabledCountryCodeStatus: true,
      preferredCountry: 'us',
      validCharactersOnly: true,
      dialCode: "",

		};
	},

	mounted() {
		this.$root.$on("ChangeUserOldData", res => {
			// console.log(res);
			this.updateUserForm.name = res.name;
			this.updateUserForm.oldName = res.name;
			this.updateUserForm.username = res.userName;
			this.updateUserForm.oldUsername = res.userName;
			this.updateUserForm.email = res.email;
			this.updateUserForm.oldEmail = res.email;
			this.updateUserForm.phone = res.phone_number;
			this.updateUserForm.oldPhone = res.phone_number;
			this.filterRolesList(res.group);
			this.getSelectGroup();
			this.customer = initService.getCustomerInfo();
		});
	},

	computed: {

		onSelectCountry({name, iso2, dialCode}) {
			this.dialCode = dialCode
		},
		isPortalAdmin() {
			return initService.getPortalAdminRole();
		},
		customerRoleStatus() {
			if (this.selectedRoles === this.newRoles) {
				return null;
			} else {
				return this.selectedRoles.length > 0;
			}
		},
		customerGroupStatus() {
			if (this.updateUserForm.customerGroup === this.updateUserForm.oldCustomerGroup) {
				return null;
			} else {
				return this.updateUserForm.customerGroup !== ""; //'Select Group';
			}
		},
		submitDisabled() {
			let valid =
				this.nameStatus ||
				this.phoneStatus ||
				this.emailStatus ||
				this.usernameStatus ||
				this.passwordStatus ||
				this.customerGroupStatus ||
				this.rolesChanged;

			return !valid;
		},
		nameStatus() {
			if (this.updateUserForm.name === this.updateUserForm.oldName) {
				return null;
			} else {
				return true;
			}
		},
		phoneStatus() {
			let scrubbedPhone = this.updateUserForm.phone
				.replaceAll(" ", "")
				.replaceAll("-", "")
				.replaceAll("(", "")
				.replaceAll(")", "");
			if (scrubbedPhone === this.updateUserForm.oldPhone) {
				return null;
			}
			return scrubbedPhone.replaceAll("+", "").length >= 10;
		},
		emailStatusMessage() {
			const re =
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			const email = String(this.updateUserForm.email).toLowerCase();

			if (re.test(email)) {
				return "";
			}

			return "Please enter a valid email.";
		},
		emailStatus() {
			if (this.updateUserForm.email === this.updateUserForm.oldEmail) {
				return null;
			} else {
				return !this.emailStatusMessage;
			}
		},
		usernameStatus() {
			if (this.updateUserForm.username.toLowerCase() === this.updateUserForm.oldUsername) {
				return null;
			}
			return this.updateUserForm.username.length > 0;
		},
		passwordStatus() {
			let valid = false;
			if (this.updateUserForm.password.length === 0) {
				valid = null;
			} else {
				valid = this.passwordLength && this.passwordUppercase && this.passwordNumber && this.passwordCharacter;
			}
			return valid;
		},
		passwordLength() {
			return this.updateUserForm.password.length > 7 ? true : false;
		},
		passwordUppercase() {
			let pass = this.updateUserForm.password;
			for (let i = 0; i < pass.length; i++) {
				if ("A" <= pass[i] && pass[i] <= "Z") {
					return true;
				}
			}
			return false;
		},
		passwordNumber() {
			let pass = this.updateUserForm.password;
			for (let i = 0; i < pass.length; i++) {
				if ("0" <= pass[i] && pass[i] <= "9") {
					return true;
				}
			}
			return false;
		},
		passwordCharacter() {
			let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
			if (format.test(this.updateUserForm.password)) {
				return true;
			} else {
				return false;
			}
		},
	},
	methods: {

		filterRolesList(roles) {
			roles.map(item => {
				if (item.includes("CARRIER_") && !item.includes("ADMIN")) {
					this.updateUserForm.customerGroup = item;
					this.updateUserForm.oldCustomerGroup = item;
				} else {
					this.selectedRoles.push(item);
				}
				this.newRoles.push(item);
			});
		},

		onSelect(e) {
			const option = e.target.value;

			if (/* option === "CARRIER_ADMIN" || */ option === "PORTAL_ADMIN") {
				if (this.selectedRoles.includes(option)) {
					const index = this.selectedRoles.indexOf(option);
					this.selectedRoles.splice(index, 1);
				} else {
					this.selectedRoles = [option];
				}
			} else {
				const index = this.selectedRoles.indexOf(option);

				if (index !== -1) {
					this.selectedRoles.splice(index, 1);
				} else {
					this.selectedRoles.push(option);
				}

				// const indexCarrierAdmin = this.selectedRoles.indexOf("CARRIER_ADMIN");
				// if (indexCarrierAdmin !== -1) {
				// 	this.selectedRoles.splice(indexCarrierAdmin, 1);
				// }

				const indexPortalAdmin = this.selectedRoles.indexOf("PORTAL_ADMIN");
				if (indexPortalAdmin !== -1) {
					this.selectedRoles.splice(indexPortalAdmin, 1);
				}
			}
		},


		removeRole(option) {
			const index = this.selectedRoles.indexOf(option);
			this.selectedRoles.splice(index, 1);
		},

		async modalClose() {
			this.$bvModal.hide("change-user");
		},

		getSelectGroup() {
			administratorService.getGroupList().then(res => {
				res.map((item, index) => {
					// if (!this.isPortalAdmin && item.GroupName === "PORTAL_ADMIN") return;
					// this.roleOption.push({value: item.GroupName, text: item.GroupName});

					if (item.GroupName.toString()==='PORTAL_ADMIN' && !initService.getPortalAdminRole()) {
						// do not show users the PORTAL_ADMIN role unless they have the role.
					} else {
						if (item.GroupName.toString().includes('CARRIER_') && !item.GroupName.toString().includes('ADMIN')) {
							this.customerGroupOptions.push({value: item.GroupName, text: item.GroupName});
						} else {
							this.roleOption.push({value: item.GroupName, text: item.GroupName});
						}
					}

				});
			});
		},

		formatPhoneNumber(phone) {
			phone = phone.replace(/\D/g, "");
			phone = phone.substr(phone.length - 10);
			if (phone.length < 10) {
				// this.$toast.error("Error: Invalid phone length <10.");
				this.showToast("Error: Invalid phone length <10.", "error");
				return phone;
			}
			phone = "+1" + phone;
			return phone;
		},

		async changeGroupSubmit() {
			let errorMessages = [];

			if (this.passwordStatus) {
				await AdministratorService.resetUserPassword(
					this.updateUserForm.username,
					this.updateUserForm.password
				).then(res => {
					this.submitLoading = false;
					let {type, msg} = handleResponse.apiResponse(res);
					if (type === "error") {
						// this.$toast(msg, {type: type});
						this.showToast(msg, type);
						errorMessages.push(msg);
					}
				});
			}
			let userCarrier = this.updateUserForm.customerGroup;

			let groupnamesToAdd = [...this.selectedRoles]; // Roles to add
			if (userCarrier.length > 0) {
				groupnamesToAdd.push(userCarrier);
			}
			const groupnamesToRemove = this.newRoles.filter(role => !groupnamesToAdd.includes(role)); // Roles to remove

			// console.log("groupnamesToAdd", groupnamesToAdd)
			// console.log("groupnamesToRemove", groupnamesToRemove)

			AdministratorService.addUserToGroup(this.updateUserForm.username, groupnamesToAdd).then(res => {
				let {type, msg} = handleResponse.apiResponse(res);
				if (type === "error") {
					// this.$toast(msg, {type: type});
					this.showToast(msg, type);
					errorMessages.push(msg);
				}
			});

			AdministratorService.removeUserFromGroup(this.updateUserForm.username, groupnamesToRemove).then(res => {
				let {type, msg} = handleResponse.apiResponse(res);
				if (type === "error") {
					// this.$toast(msg, {type: type});
					this.showToast(msg, type);
					errorMessages.push(msg);
				}
			});

			// if (this.customerGroupStatus && this.phoneStatus && this.emailStatus && this.usernameStatus) {
			let errors = false;
			this.submitLoading = true;
			const userArttributes = [
				{Name: "name", Value: this.updateUserForm.name},
				{Name: "email", Value: this.updateUserForm.email},
				{Name: "phone_number", Value: this.formatPhoneNumber(this.updateUserForm.phone)},
			];

			const oldUserArttributes = [
				{Name: "name", Value: this.updateUserForm.oldName},
				{Name: "email", Value: this.updateUserForm.oldEmail},
				{Name: "phone_number", Value: this.formatPhoneNumber(this.updateUserForm.oldPhone)},
			];

			if (
				userArttributes &&
				userArttributes !== "" &&
				JSON.stringify(userArttributes) !== JSON.stringify(oldUserArttributes)
			) {
				await AdministratorService.updateUserProfile(this.updateUserForm.username, userArttributes).then(
					res => {
						let {type, msg} = handleResponse.apiResponse(res);
						if (type === "error") {
							// this.$toast(msg, {type: type});
							this.showToast(msg, type);
							errorMessages.push(msg);
						}
					}
				);
			}

			//finished
			if (!errors) {
				this.$root.$emit("getUserList");
				this.modalClose();

				// update session storage if current user is updated
				if (this.updateUserForm.username === configDirective.getCurrentUser().username) {
					// console.log("update session storage");
					sessionStorage.setItem(
						"IOT_GetCurrentUser",
						JSON.stringify({
							...configDirective.getCurrentUser(),
							name: this.updateUserForm.name,
							email: this.updateUserForm.email,
							phone_number: this.updateUserForm.phone,
						})
					);
				}
			} else {
				// this.$toast("There were errors processing all the changes. You may want to save your changes again.", {
				// 	type: type,
				// });
				this.showToast(
					"There were errors processing all the changes. You may want to save your changes again.",
					type
				);
			}

			if (errorMessages.length === 0) {
				// this.$toast(`"PASS - User update successful"`, {type: "success"});
				this.showToast(`"PASS - User update successful"`, "success");
			}
		},

		showToast(message, variant = "error") {
			//setup for alert
			this.$toast(
				{
					component: Toast,
					props: {
						title: "User Update",
						description: message,
					},
				},
				{
					type: variant,
				}
			);
		},

		onBlur(event) {
			if (!event) {
				if (this.updateUserForm.phone === "") {
					this.updateUserForm.phone = this.updateUserForm.oldPhone;
					return;
				}
			} else {
				switch (event.target.id) {
					case "email":
						if (this.updateUserForm.email === "") {
							this.updateUserForm.email = this.updateUserForm.oldEmail;
						}
						break;
					case "name":
						if (this.updateUserForm.name === "") {
							this.updateUserForm.name = this.updateUserForm.oldName;
						}
						break;
					case "phone-number":
						if (this.updateUserForm.phone === "") {
							this.updateUserForm.phone = this.updateUserForm.oldPhone;
						}
						break;
					case "password":
						if (this.updateUserForm.password.length === 0) {
							this.stateOverride = true;
						} else {
							this.stateOverride = false;
						}
						break;
					default:
						break;
				}
			}
		},
		setStateOverride(state) {
			this.stateOverride = state;
		},
	},
	watch: {
		selectedRoles: {
			handler(newVal) {
				if (JSON.stringify(newVal) !== JSON.stringify(this.newRoles)) {
					this.rolesChanged = true;
				} else {
					this.rolesChanged = false;
				}
			},
			deep: true,
		},
	},
};
</script>
